import * as React from 'react';
import ExpansionList from '../../../../common/expansion-list';
import Client from '../../../../../models/client';
import { useSupportFields } from '../../../../../hooks/useSupportFields';
import HiddenRequestTypeFields from '../../../../../models/hiddenRequestTypeFields';
import _ from 'lodash';
import SupportAllowedTypeFields from '../../../../../models/supportAllowedTypeFields';
import * as styles from '../client-admin.module.scss';

interface Props {
  client: Client;
  // FormikHelper.setFieldValue
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

const ServiceDeskFields = ({ client, setFieldValue }: Props) => {
  const { data } = useSupportFields();
  // The unchecked service type fields are considered hidden.
  const [hiddenRequestTypeFields, setHiddenRequestTypeFields] = React.useState<HiddenRequestTypeFields[]>();

  React.useEffect(() => {
    if (data) {
      if (client.hiddenRequestTypeFields.length == 0) {
        setHiddenRequestTypeFields(data.initialHiddenFields);
      } else {
        const defaultHiddenRequestTypesWithSavedTypes = _.unionWith(
          client.hiddenRequestTypeFields,
          data.initialHiddenFields,
          function(group: HiddenRequestTypeFields, defaultGroup: HiddenRequestTypeFields) {
            return defaultGroup.key == group.key;
          }
        );
        setHiddenRequestTypeFields(defaultHiddenRequestTypesWithSavedTypes);
      }
    }
  }, [data]);

  return (
    <React.Fragment>
      <h2 className={styles.formSectionHeading}>Service Desk Fields</h2>
      <div className={styles.serviceDeskFieldsSection}>
        {data &&
          hiddenRequestTypeFields &&
          data.requestTypeFields.map((requestTypeFieldsGroup: SupportAllowedTypeFields, index: number) => {
            const hiddenRequestTypeFieldsInGroup = hiddenRequestTypeFields.find(hiddenRequestTypeFieldsGroup => {
              return hiddenRequestTypeFieldsGroup.key === requestTypeFieldsGroup.value;
            });
            return (
              <ExpansionList
                key={index}
                typeFields={requestTypeFieldsGroup}
                uncheckedFields={hiddenRequestTypeFieldsInGroup}
                setUncheckedFields={setHiddenRequestTypeFields}
                setFieldValue={setFieldValue}
                setField="hiddenRequestTypeFields"
              />
            );
          })}
      </div>
    </React.Fragment>
  );
};

export default ServiceDeskFields;
